export const API_HOST_NAME = window.__RUNTIME_CONFIG__?.VITE_API_URL || 'https://paas.okonomi.cloud'
